import React, {Component} from 'react'
import { Table } from 'components/UI'
import moment from 'moment'
import {confirm} from 'util/confirm'
import { connect } from 'react-redux';
import ClockInOutModal from 'template/Modals/ClockInOut'
import FilterBy from 'template/FilterBy';

import getClockTime from 'controllers/teacher/getClockTime'
import deleteClockTime from 'controllers/teacher/deleteClockTime'
import ClockCardStatistic from '../Statistics/clockCardStatistic';
import __R, { userCan } from 'containers/__R'
import locale from '../locale'

const mapStateToProps = (state) => ({
  user: state.user,
})

const ITEMSCOUNTPERPAGE = 100

class clockTimeTable extends Component{
  constructor(props){
    super(props)

    this.state = {
      fetching: false,
      clockTimeList: [],
      startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      endDate: null,
      data: null,
      page: 1,
      count: 0,
      filterData: {
        daterange: {}
      },
      filterTypes: ['daterange'],
      showClockCardStatistic: false
    }

    this.openClockInOutModal = this.openClockInOutModal.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.showClockCardStatistic = this.showClockCardStatistic.bind(this);
  }

  componentDidMount(){
    this.fetchClockTime();
  }

  fetchClockTime(){
    const schoolId = localStorage.getItem('schoolId');
    const {startDate, endDate, page} = this.state;
    const {teacherId} = this.props;

    getClockTime(schoolId, {
      page,
      start_date: startDate,
      end_date: endDate,
      teacher: teacherId,
    })
    .then((res) => {this.setState({clockTimeList: res.results, count: res.count})})
    .catch((err) => {console.log(err)})
  }

  openClockInOutModal(){
    const {teacherId} = this.props;
    let dataToModal = this.state.data === null ? {teacher: teacherId} : this.state.data
    const MODE = this.state.data === null ? 'create' : 'update'

    ClockInOutModal({data: dataToModal, mode: MODE})
    .then((res) => {
      if(res.result === 'success'){
        this.fetchClockTime()
      }
      this.setState({data: null})
    })
    .catch((err) => {this.setState({data: null})})
  }
  showClockCardStatistic(){
    this.setState( state => {
      return {showClockCardStatistic: !state.showClockCardStatistic};
    });
  }
  onFilterChange(change){
		const {filterData } = change

    let startDate;
    let endDate;

    if((filterData.daterange.startDate && !filterData.daterange.endDate) || (!filterData.daterange.startDate && filterData.daterange.endDate)){
      return
    } 

    if(filterData.daterange){
      if(filterData.daterange.endDate && filterData.daterange.startDate){
        startDate = moment(filterData.daterange.startDate).format('YYYY-MM-DD');
        endDate = moment(filterData.daterange.endDate).format('YYYY-MM-DD')
      } else if (filterData.daterange.endDate === null && filterData.daterange.startDate === null){
        startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
        endDate = null
      }
    }

    this.setState({
      filterData, 
      startDate: startDate,
      endDate: endDate,
    }, () => {
      this.fetchClockTime()
    })
  }

  onPageChange(activePage){
    this.setState({page: activePage}, () => {
      this.fetchClockTime()
    })
  }

  render(){
    const schoolId = localStorage.getItem('schoolId')
    const {filterData, startDate, endDate, count, page, showClockCardStatistic} = this.state;
    const { teacherId, teacherInfo } = this.props;
    const daterangeOptions = {
      startDate: filterData.daterange.startDate || moment(startDate),
      endDatePlaceholderText: __('Today', 'teacherAttendance')
    }
    const pagination = {totalItemsCount: count, activePage: page, itemsCountPerPage: ITEMSCOUNTPERPAGE, showItemCount: false}

    const fields = [{
      name: 'date',
      title: __('Date', locale),
      getTdContent: ({ trData: data })=>{
        return <div>{moment(data.punched_at).format('YYYY-MM-DD')}</div>
      },
    }, {
      name: 'time',
      title: __('Time', locale),
      getTdContent: ({ trData: data })=>{
        return <div>{moment(data.punched_at).format('hh:mm a')}</div>
      },
    }, {
      name: 'operation_type',
      title: __('Clock In/Clock Out', locale),
      getTdContent: ({ trData: data })=>{
        return <div>{data.operation_type === 1 ? __('Clock In', locale) : __('Clock Out', locale) }</div>
      },
    }, {
      name: 'name',
      title: __('Operator', locale),
      getTdContent: ({ trData: data })=>{
        return <div>{data.operator_name ? data.operator_name : __('Principal', locale)}</div>
      },
    }]

    const settings = [
      {
        title: __('Edit', locale),
        onClick: ({trData: data})=>{
          this.setState({data}, () => {this.openClockInOutModal()})
        },
      },
      {
        title: __('Delete', locale),
        onClick: ({trData: data})=>{
          confirm(__('Proceed to delete this record?', locale))
          .then(() => { 
            deleteClockTime(schoolId, data.id)
            .then((res) => {this.fetchClockTime()})
            .catch((err) => {console.log(err)})
          })
          .catch(() => {})
        },
      }
    ]

    return(
      <div className='clockTimeTableContainer'>
      <div className='clockTimeHeader'>
        <h2>{__('Clock Card', locale)}</h2>
        <div>
          <button className='btn btn-default' disabled={teacherInfo.archived} onClick={this.showClockCardStatistic}>
            {__('Calculate Salary', locale)}
          </button>
          <button className='btn btn-default' disabled={teacherInfo.archived} onClick={this.openClockInOutModal}>
            {__('Clock In/Out', locale)}
          </button>
        </div>
      </div>
        <FilterBy
          filterData={this.state.filterData}
          filters={this.state.filterTypes}
          options={{daterange: daterangeOptions}}
          schoolId={schoolId}
          onChange={this.onFilterChange}
        />
        <ClockCardStatistic 
          startDate={startDate} 
          endDate={endDate} 
          teacherId={teacherId}
          isShow={showClockCardStatistic}
        />
        <Table
          data={this.state.clockTimeList}
          fields={fields}
          className='clockTimeTable'
          settingThTitle={' '}
          settingWidth={'15%'}
          settings={settings}
          useMultiSelection={false}
          oneSettingPerRow={false}
          hideDropdownCaret={true}
          fetching={this.state.fetching}
          dropdownGuideWidth={160}
          dropdownGuideHeight={228}
          hasTopUtilSection={true}
          pagination={pagination}
          usePagination={true}
          onPageChange={this.onPageChange}
        />
      </div>
    )
  }
}


export default connect(mapStateToProps)(clockTimeTable)



// WEBPACK FOOTER //
// ./src/template/Docks/TeacherInfo/Tables/clockTimeTable.js